function getPlaceholder(params) {
  const {
    placeholder,
    label,
    bulkMode,
    isDropdown
  } = params;
  const bulkHandler = bulkMode ? '<Mixed>' : placeholder || '';
  if (bulkHandler) {
    return bulkHandler;
  }
  if (label && typeof label === 'string') {
    if (isDropdown) {
      return "Choose ".concat(label);
    } else {
      return "Enter ".concat(label);
    }
  }
  return '';
}

export { getPlaceholder };
